var map = {
	"../patient-detail/patient-detail.module": [
		"./src/app/patient-detail/patient-detail.module.ts",
		"default~patient-detail-patient-detail-module~patients-patients-module~reports-reports-module~setting~93ed8142",
		"default~patient-detail-patient-detail-module~patients-patients-module~settings-settings-module"
	],
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"auth-auth-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./ipd-discharge-summary/ipd-discharge-summary.module": [
		"./src/app/ipd-discharge-summary/ipd-discharge-summary.module.ts",
		"ipd-discharge-summary-ipd-discharge-summary-module"
	],
	"./opd-appointment-list-view/opd-appointment-list-view.module": [
		"./src/app/opd-appointment-list-view/opd-appointment-list-view.module.ts",
		"opd-appointment-list-view-opd-appointment-list-view-module"
	],
	"./opd-calendar-view/opd-calendar-view.module": [
		"./src/app/opd-calendar-view/opd-calendar-view.module.ts",
		"opd-calendar-view-opd-calendar-view-module"
	],
	"./outpatients/outpatients.module": [
		"./src/app/outpatients/outpatients.module.ts",
		"outpatients-outpatients-module"
	],
	"./patient-chart-dental/patient-chart-dental.module": [
		"./src/app/patient-chart-dental/patient-chart-dental.module.ts",
		"patient-chart-dental-patient-chart-dental-module"
	],
	"./patient-dentistry/patient-dentistry.module": [
		"./src/app/patient-detail/patient-dentistry/patient-dentistry.module.ts",
		"patient-dentistry-patient-dentistry-module"
	],
	"./patient-detail/patient-detail.module": [
		"./src/app/patient-detail/patient-detail.module.ts",
		"default~patient-detail-patient-detail-module~patients-patients-module~reports-reports-module~setting~93ed8142",
		"default~patient-detail-patient-detail-module~patients-patients-module~settings-settings-module"
	],
	"./patients/patients.module": [
		"./src/app/patients/patients.module.ts",
		"default~patient-detail-patient-detail-module~patients-patients-module~reports-reports-module~setting~93ed8142",
		"default~patient-detail-patient-detail-module~patients-patients-module~settings-settings-module",
		"patients-patients-module"
	],
	"./plan-and-billing/plan-and-billing.module": [
		"./src/app/plan-and-billing/plan-and-billing.module.ts",
		"plan-and-billing-plan-and-billing-module"
	],
	"./reports/reports.module": [
		"./src/app/reports/reports.module.ts",
		"default~patient-detail-patient-detail-module~patients-patients-module~reports-reports-module~setting~93ed8142",
		"reports-reports-module"
	],
	"./settings/settings.module": [
		"./src/app/settings/settings.module.ts",
		"default~patient-detail-patient-detail-module~patients-patients-module~reports-reports-module~setting~93ed8142",
		"default~patient-detail-patient-detail-module~patients-patients-module~settings-settings-module",
		"settings-settings-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;